import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div id=\"inject\" class={{@injectClass}}></div>",{ moduleName: "garaje/pods/components/react-app/template.hbs" })